module.exports = __webpack_public_path__ + "img/0Q3A6078_L_Black_MockedUp.72d08ce5.jpg";